import script from "./OrganizationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&setup=true&lang=js"

import "./OrganizationPage.vue?vue&type=style&index=0&id=18834e6a&scoped=true&lang=css"
script.__scopeId = "data-v-18834e6a"

export default script